"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createRequestsReducer = void 0;

var _actions = require("./actions");

var _selectRequestByConfig = require("../../selectors/selectRequestByConfig");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var arrayErrorsToErrorsByName = function arrayErrorsToErrorsByName(errors) {
  return Object.values(errors).reduce(function (acc, error) {
    return _objectSpread(_objectSpread({}, acc), error);
  }, {});
};

var parseHeaders = function parseHeaders(headers) {
  return headers && {
    hasMore: headers['has-more'] === 'False' ? false : true,
    page: headers['page'],
    totalDataCount: headers['total-data-count'] ? parseInt(headers['total-data-count'], 10) : null
  };
};

var createRequestsReducer = function createRequestsReducer() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    var _ref = action || {},
        _ref$config = _ref.config,
        config = _ref$config === void 0 ? {} : _ref$config;

    var key = (0, _selectRequestByConfig.keyFromConfig)(config);

    if (/FAIL_DATA_(DELETE|GET|POST|PUT|PATCH)_(.*)/.test(action.type)) {
      var nextState = _defineProperty({}, key, _objectSpread(_objectSpread({}, state[key]), {}, {
        date: new Date(Date.now()).toISOString(),
        errors: arrayErrorsToErrorsByName(action.payload.errors),
        headers: parseHeaders(action.payload.headers),
        isFail: true,
        isPending: false,
        isSuccess: false
      }));

      return _objectSpread(_objectSpread({}, state), nextState);
    }

    if (/REQUEST_DATA_(DELETE|GET|POST|PUT|PATCH)_(.*)/.test(action.type)) {
      var _nextState2 = _defineProperty({}, key, _objectSpread(_objectSpread({}, state[key]), {}, {
        date: new Date(Date.now()).toISOString(),
        errors: null,
        isFail: false,
        isPending: true,
        isSuccess: false
      }));

      return _objectSpread(_objectSpread({}, state), _nextState2);
    }

    if (/SUCCESS_DATA_(DELETE|GET|POST|PUT|PATCH)_(.*)/.test(action.type)) {
      var _nextState4 = _defineProperty({}, key, _objectSpread(_objectSpread({}, state[key]), {}, {
        date: new Date(Date.now()).toISOString(),
        errors: null,
        headers: parseHeaders(action.payload.headers),
        isFail: false,
        isPending: false,
        isSuccess: true
      }));

      return _objectSpread(_objectSpread({}, state), _nextState4);
    }

    if (action.type === _actions.DELETE_REQUESTS) {
      var _nextState6 = _defineProperty({}, action.key, undefined);

      return _objectSpread(_objectSpread({}, state), _nextState6);
    }

    if (action.type === _actions.REINITIALIZE_REQUESTS) {
      return initialState;
    }

    return state;
  };

  return reducer;
};

exports.createRequestsReducer = createRequestsReducer;
var _default = createRequestsReducer;
exports["default"] = _default;